export type PwaInstallCardVariant = 'hidden' | 'android' | 'ios' | 'installed';

export function getPwaInstallCardVariant(input: {
  hasGeneratedPdf: boolean;
  canInstall: boolean;
  isInstalled: boolean;
  isIos: boolean;
  isStandalone: boolean;
}): PwaInstallCardVariant {
  if (!input.hasGeneratedPdf || input.isStandalone) return 'hidden';
  if (input.isInstalled) return 'installed';
  if (input.isIos) return 'ios';
  return input.canInstall ? 'android' : 'hidden';
}
